/**
 * Ediwin alert notify
 *
 * @param {*} title
 * @param {*} content
 * @param {*} timeout
 * @returns
 */
export function showErrorAlert(title, content, timeout = 4000) {
  title = edicom.locale.translate(title || 'global.warningMsg');
  content = edicom.locale.translate(content || 'global.pleaseRetryLater');
  return edicom.notif.alert({ type: 'danger', title, content, timeout });
}
